import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
import VeltCommentsSidebarStatusDropdownContentWireframe from '../../VeltCommentsSidebarStatusDropdownWireframe/VeltCommentsSidebarStatusDropdownContentWireframe/VeltCommentsSidebarStatusDropdownContentWireframe';
import VeltCommentsSidebarStatusDropdownTriggerWireframe from '../../VeltCommentsSidebarStatusDropdownWireframe/VeltCommentsSidebarStatusDropdownTriggerWireframe/VeltCommentsSidebarStatusDropdownTriggerWireframe';
;
var VeltCommentsSidebarStatus = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-status-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarStatus.Trigger = VeltCommentsSidebarStatusDropdownTriggerWireframe;
VeltCommentsSidebarStatus.Content = VeltCommentsSidebarStatusDropdownContentWireframe;
export default VeltCommentsSidebarStatus;
